<template>
    <div>
        <div class="content-wrapper mb-3">
            <section class="content-header">
                <div
                    class="overflow-hidden"
                    style="
                        border-bottom: 1px solid #00000017;
                        height: 65px !important;
                    "
                >
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1>Recurring Migration</h1>
                            <ol class="breadcrumb float-sm-left">
                                <router-link
                                    tag="li"
                                    class="breadcrumb-item"
                                    :to="{ name: 'Home' }"
                                    >Home</router-link
                                >
                                <router-link
                                    tag="li"
                                    class="breadcrumb-item"
                                    :to="{ name: 'Dashboard' }"
                                    >Dashboard</router-link
                                >
                                <li class="breadcrumb-item active">
                                    Recurring Migration
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <div class="container">
                <div class="row">
                    <div
                        class="d-flex justify-content-center align-items-center flex-column"
                    >
                        <div class="w-100">
                            <!-- SELECT DOMAINS FROM COLUMN -->
                            <div class="col-12">
                                <v-card-title
                                    class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                                >
                                    <div
                                        class="d-flex justify-content-between align-items-center border-bottom w-100"
                                    >
                                        <div class="text-left py-1 pl-1 w-100">
                                            <span class="step-number ml-2 mr-1"
                                                >1</span
                                            >
                                            <span
                                                style="font-size: 11px"
                                                class="mr-4"
                                                >STEP</span
                                            >
                                            <span
                                                class="font-size-11 font-weight-400"
                                                >SELECT DOMAINS FROM:
                                                {{
                                                    dmnsFrom[0] !== undefined
                                                        ? dmnsFrom[0].length
                                                        : 0
                                                }}</span
                                            >
                                        </div>
                                        <v-autocomplete
                                            v-if="roles.includes('moder')"
                                            v-model="selectedClientFrom"
                                            label="Select a Client"
                                            outlined
                                            single-line
                                            hide-details
                                            dense
                                            :items="getClients"
                                            item-value="client_uid"
                                            item-text="name"
                                            class="py-4 pr-4 m-0"
                                        ></v-autocomplete>
                                    </div>
                                    <div class="d-flex ml-2">
                                        <v-tooltip left>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    v-show="
                                                        selectedDmnsFrom.length
                                                    "
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        selectedDmnsFrom = []
                                                    "
                                                >
                                                    mdi-close-circle-outline
                                                </v-icon>
                                            </template>
                                            <span
                                                >Click to purge selection.</span
                                            >
                                        </v-tooltip>
                                        <span
                                            class="ml-1"
                                            style="font-size: 45% !important"
                                        >
                                            SELECTED:
                                            {{ selectedDmnsFrom.length }}
                                        </span>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="searchDmnsFrom"
                                        append-icon="mdi-magnify"
                                        label="Search Domain"
                                        single-line
                                        hide-details
                                        :disabled="loading"
                                        :loading="loading"
                                        class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                                        style="
                                            width: 97%;
                                            border: 1px solid #d1d1d1 !important;
                                        "
                                    ></v-text-field>
                                </v-card-title>

                                <v-card
                                    class="elevation-1 border"
                                    style="margin: 0 !important"
                                >
                                    <v-data-table
                                        v-model="selectedDmnsFrom"
                                        :headers="dmnsFromHeaders"
                                        :loading="
                                            loading &&
                                            !filteredDomainsFrom.length
                                        "
                                        :items="filteredDomainsFrom"
                                        item-key="id"
                                        :show-select="
                                            !loading && !processLoading
                                        "
                                        single-select
                                        @toggle-select-all="
                                            selectedDmnsFrom.length !==
                                            dmnsFrom[0].length
                                                ? (selectedDmnsFrom =
                                                      dmnsFrom[0])
                                                : (selectedDmnsFrom = [])
                                        "
                                        class="elevation-1 border"
                                        style="overflow-y: auto"
                                    >
                                        <template
                                            v-slot:[`item.url`]="{ item }"
                                        >
                                            <td
                                                class="border-bottom border-left text-left my-2"
                                                style="padding: 10px 16px"
                                            >
                                                {{ item.url }}
                                            </td>
                                        </template>
                                        <template
                                            v-slot:[`item.domain_tags`]="{
                                                item,
                                            }"
                                        >
                                            <td
                                                class="border-left border-right border-top text-left"
                                            >
                                                <div
                                                    class="d-flex align-items-center my-2 overflow-auto"
                                                    v-if="
                                                        item.domain_tags !==
                                                            undefined &&
                                                        item.domain_tags.length
                                                    "
                                                >
                                                    <v-chip
                                                        v-for="tag in item.domain_tags"
                                                        :key="tag.id"
                                                        class="font-weight-medium text-sm-body-2 cursor-pointer mr-2"
                                                        :class="{
                                                            'red lighten-4':
                                                                tag.type ===
                                                                'geo',
                                                            'blue lighten-4':
                                                                tag.type ===
                                                                'adult',
                                                            'deep-orange lighten-4':
                                                                tag.type ===
                                                                'category',
                                                            'purple lighten-4':
                                                                tag.type ===
                                                                'server',
                                                        }"
                                                        label
                                                        small
                                                        @click.prevent="
                                                            searchDmnsFrom =
                                                                tag.name
                                                        "
                                                        >{{ tag.name }}</v-chip
                                                    >
                                                </div>
                                            </td>
                                        </template>
                                        <template
                                            v-slot:[`item.status`]="{ item }"
                                        >
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <span
                                                    class="inActiveStatusSign mr-1"
                                                    :class="{
                                                        activeStatusSign:
                                                            item.is_active,
                                                    }"
                                                >
                                                </span>
                                                <span
                                                    class="inActiveStatus"
                                                    :class="{
                                                        activeStatus:
                                                            item.is_active,
                                                    }"
                                                >
                                                    {{
                                                        item.is_active
                                                            ? "Active"
                                                            : "Inactive"
                                                    }}
                                                </span>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </div>

                            <!-- SELECT DOMAINS TO COLUMN  -->
                            <div class="col-12">
                                <v-card-title
                                    class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                                >
                                    <div
                                        class="d-flex justify-content-between align-items-center w-100 border-bottom"
                                    >
                                        <div class="text-left py-1 pl-1 w-100">
                                            <span class="step-number ml-2 mr-1"
                                                >2</span
                                            >
                                            <span
                                                style="font-size: 11px"
                                                class="mr-4"
                                                >STEP</span
                                            >
                                            <span
                                                class="font-size-11 font-weight-400"
                                                >SELECT DOMAINS TO:
                                                {{
                                                    dmnsTo[0] !== undefined
                                                        ? dmnsTo[0].length
                                                        : 0
                                                }}</span
                                            >
                                        </div>
                                        <v-autocomplete
                                            v-if="roles.includes('moder')"
                                            v-model="selectedClientTo"
                                            label="Select a Client"
                                            outlined
                                            dense
                                            single-line
                                            hide-details
                                            :items="getClients"
                                            item-value="client_uid"
                                            item-text="name"
                                            class="py-4 pr-4 m-0"
                                        ></v-autocomplete>
                                    </div>
                                    <div class="d-flex ml-2">
                                        <v-tooltip left>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    v-show="
                                                        selectedDmnsTo.length
                                                    "
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="selectedDmnsTo = []"
                                                >
                                                    mdi-close-circle-outline
                                                </v-icon>
                                            </template>
                                            <span
                                                >Click to purge selection.</span
                                            >
                                        </v-tooltip>
                                        <span
                                            class="ml-1"
                                            style="font-size: 45% !important"
                                        >
                                            SELECTED:
                                            {{ selectedDmnsTo.length }}
                                        </span>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="searchDmnsTo"
                                        append-icon="mdi-magnify"
                                        label="Search Domain"
                                        :disabled="loading"
                                        :loading="loading"
                                        single-line
                                        hide-details
                                        class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                                        style="
                                            width: 97%;
                                            border: 1px solid #d1d1d1 !important;
                                        "
                                    ></v-text-field>
                                </v-card-title>

                                <v-card
                                    class="elevation-1 border"
                                    style="margin: 0 !important"
                                >
                                    <v-data-table
                                        v-model="selectedDmnsTo"
                                        :headers="dmnsToHeaders"
                                        :items="filteredDomainsTo"
                                        :loading="
                                            loading && !filteredDomainsTo.length
                                        "
                                        item-key="id"
                                        show-select
                                        single-select
                                        @toggle-select-all="
                                            selectedDmnsTo.length !==
                                            dmnsTo[0].length
                                                ? (selectedDmnsTo = dmnsTo[0])
                                                : (selectedDmnsTo = [])
                                        "
                                        class="elevation-1"
                                        style="overflow-y: auto"
                                    >
                                        <template
                                            v-slot:[`item.url`]="{ item }"
                                        >
                                            <td
                                                class="border-bottom border-left text-left my-2"
                                                style="padding: 10px 16px"
                                            >
                                                {{ item.url }}
                                            </td>
                                        </template>
                                        <template
                                            v-slot:[`item.tags`]="{ item }"
                                        >
                                            <td
                                                class="border-top border-left border-right text-left"
                                            >
                                                <div
                                                    class="d-flex align-items-center my-2 overflow-auto"
                                                    v-if="
                                                        item.domain_tags !==
                                                            undefined &&
                                                        item.domain_tags.length
                                                    "
                                                >
                                                    <v-chip
                                                        v-for="tag in item.domain_tags"
                                                        :key="tag.id"
                                                        class="font-weight-medium text-sm-body-2 cursor-pointer mr-2"
                                                        :class="{
                                                            'red lighten-4':
                                                                tag.type ===
                                                                'geo',
                                                            'blue lighten-4':
                                                                tag.type ===
                                                                'adult',
                                                            'deep-orange lighten-4':
                                                                tag.type ===
                                                                'category',
                                                            'purple lighten-4':
                                                                tag.type ===
                                                                'server',
                                                        }"
                                                        label
                                                        small
                                                        >{{ tag.name }}</v-chip
                                                    >
                                                </div>
                                            </td>
                                        </template>
                                        <template
                                            v-slot:[`item.status`]="{ item }"
                                        >
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <span
                                                    class="inActiveStatusSign mr-1"
                                                    :class="{
                                                        activeStatusSign:
                                                            item.is_active,
                                                    }"
                                                >
                                                </span>
                                                <span
                                                    class="inActiveStatus"
                                                    :class="{
                                                        activeStatus:
                                                            item.is_active,
                                                    }"
                                                >
                                                    {{
                                                        item.is_active
                                                            ? "Active"
                                                            : "Inactive"
                                                    }}
                                                </span>
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-card>
                                <!-- </v-tab-item>
                  </v-tabs-items> -->
                            </div>

                            <!-- SELECT TYPES COLUMN -->
                            <div class="col-12 d-flex flex-column">
                                <v-card-title
                                    class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                                >
                                    <div class="text-left py-1 pl-1 w-100">
                                        <span class="step-number ml-2 mr-1"
                                            >3</span
                                        >
                                        <span
                                            style="font-size: 11px"
                                            class="mr-4"
                                            >STEP</span
                                        >
                                        <span
                                            class="font-size-11 font-weight-400"
                                            >SELECT TYPES:
                                            {{ types.length }}</span
                                        >
                                    </div>
                                    <small
                                        class="ml-4"
                                        style="font-size: 45% !important"
                                    >
                                        SELECTED: {{ selectedTypes.length }}
                                    </small>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-data-table
                                    v-model="selectedTypes"
                                    :headers="typesHeaders"
                                    :items="types"
                                    item-key="type"
                                    hide-default-footer
                                    show-select
                                    class="elevation-1 w-100"
                                    style="overflow-y: auto"
                                    :items-per-page="-1"
                                >
                                    <template v-slot:[`item.type`]="{ item }">
                                        <td
                                            class="border-bottom border-left text-left my-2"
                                            style="padding: 10px 16px"
                                        >
                                            {{ item.type }}
                                        </td></template
                                    >
                                </v-data-table>
                            </div>

                            <!-- RECURRING DRIPS LIST -->
                            <div
                                class="col-12"
                                v-if="
                                    selectedTypes.find(
                                        (el) => el.type === 'Recurring Drips'
                                    )
                                "
                            >
                                <v-card-title
                                    class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                                >
                                    <div
                                        class="text-left border-bottom py-1 pl-1 w-100 position-relative"
                                    >
                                        <span class="step-number ml-2 mr-1"
                                            >4.1</span
                                        >
                                        <span
                                            style="font-size: 11px"
                                            class="mr-4"
                                            >STEP</span
                                        >
                                        <span
                                            class="font-size-11 font-weight-400"
                                            >RECURRING DRIPS:
                                            {{ recurrings.length }}</span
                                        >
                                        <div
                                            class="position-absolute d-flex align-items-center h-100"
                                            style="
                                                top: 0;
                                                right: 7px;
                                                max-height: 200px;
                                            "
                                        >
                                            <!-- <v-select
                          v-model="selectedRecurringStatus"
                          height="21"
                          :items="[
                            { text: 'Inactive', value: 0 },
                            { text: 'Active', value: 1 },
                          ]"
                          clearable
                          dense
                          class="v-combobox--type mr-3 mt-7"
                        ></v-select> -->
                                            <!-- <v-menu bottom @input="toggleMenu">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="#007bff"
                              style="font-size: 12px"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              Sorting by:
                            </v-btn>
                          </template>
                          <v-treeview
                            :items="itemsSendTime"
                            :open="openTreeview"
                            @update:active="treeviewActiveSendTime"
                            activatable
                            hoverable
                          >
                            <template #label="{ item }">
                              <span style="cursor: pointer">{{ item.name }}</span>
                            </template>
                          </v-treeview>
                          <v-treeview
                            :items="itemsAudienceFilters"
                            :open="openTreeview"
                            @input="treeviewActiveAudienceFilters"
                            selectable
                            multiple-active
                            activatable
                            hoverable
                          >
                            <template #label="{ item }">
                              <span style="cursor: pointer">{{ item.name }}</span>
                            </template>
                          </v-treeview>
                        </v-menu> -->
                                        </div>
                                    </div>
                                    <div class="d-flex ml-2">
                                        <v-tooltip left>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    v-show="
                                                        selectedRecurrings.length
                                                    "
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        selectedRecurrings = []
                                                    "
                                                >
                                                    mdi-close-circle-outline
                                                </v-icon>
                                            </template>
                                            <span
                                                >Click to purge selection.</span
                                            >
                                        </v-tooltip>
                                        <span
                                            class="ml-1"
                                            style="font-size: 45% !important"
                                        >
                                            SELECTED:
                                            {{ selectedRecurrings.length }}
                                        </span>
                                        <!-- <v-select
                                            v-model="selectedScheduleRelation"
                                            :items="[
                                                'Recurring',
                                                'Tail Recurring',
                                            ]"
                                            dense
                                            style="
                                                position: absolute;
                                                top: 42px;
                                                right: 37px;
                                            "
                                        ></v-select> -->
                                    </div>
                                    <!-- <br class="d-none" />
                    <small class="ml-4" style="font-size: 45% !important">
                      SELECTED AUDIENCE FILTER:
                      {{
                        selectedAudienceFiltersForSorting.length
                          ? audienceList.find(
                              (el) =>
                                el.id === selectedAudienceFiltersForSorting[0]
                            )["name"]
                          : "All"
                      }}
                    </small>
                    <br class="d-none" />
                    <small class="ml-4" style="font-size: 45% !important">
                      SELECTED SEND TIME:
                      {{
                        selectedSendTimeForSorting.length
                          ? selectedSendTimeForSorting[0]
                          : "All"
                      }}
                    </small> -->
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="searchRecurrings"
                                        append-icon="mdi-magnify"
                                        label="Search ID or Title or Message"
                                        :disabled="loading"
                                        :loading="loading"
                                        single-line
                                        hide-details
                                        class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                                        style="
                                            width: 97%;
                                            border: 1px solid #d1d1d1 !important;
                                        "
                                    ></v-text-field>
                                </v-card-title>
                                <v-card
                                    class="elevation-1 border"
                                    style="margin: 0 !important"
                                >
                                    <v-data-table
                                        v-model="selectedRecurrings"
                                        :headers="recurringsHeaders"
                                        :items="filteredRecurrings"
                                        :loading="
                                            !recurrings.length && loadingRecur
                                        "
                                        show-select
                                        @toggle-select-all="
                                            selectedRecurrings.length !==
                                            recurrings.length
                                                ? (selectedRecurrings =
                                                      recurrings)
                                                : (selectedRecurrings = [])
                                        "
                                        class="elevation-1"
                                        style="overflow-y: auto"
                                    >
                                        <template v-slot:[`item.id`]="{ item }">
                                            <td
                                                class="border-left border-right"
                                                style="
                                                    width: 100px;
                                                    height: 50px;
                                                "
                                            >
                                                {{ item.id }}
                                            </td></template
                                        >
                                        <template
                                            v-slot:[`item.title`]="{ item }"
                                        >
                                            <strong>{{ item.title }}</strong>
                                            <br />
                                            {{ item.body }}
                                            <br />
                                            <v-edit-dialog
                                                :return-value.sync="item.url"
                                            >
                                                <v-tooltip left>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs,
                                                        }"
                                                    >
                                                        <span
                                                            class="recurring-link"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            {{ item.url }}
                                                        </span>
                                                    </template>
                                                    <span>Click To Reveal</span>
                                                </v-tooltip>
                                                <template v-slot:input>
                                                    <v-text-field
                                                        v-model="item.url"
                                                        color="#2196f3"
                                                        single-line
                                                        counter
                                                    ></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </template>
                                        <template
                                            v-slot:[`item.status`]="{ item }"
                                        >
                                            <td class="text-left border-left">
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <span
                                                        class="inActiveStatusSign mr-1 border-left"
                                                        :class="{
                                                            activeStatusSign:
                                                                item.is_active,
                                                        }"
                                                    >
                                                    </span>
                                                    <span
                                                        class="inActiveStatus"
                                                        :class="{
                                                            activeStatus:
                                                                item.is_active,
                                                        }"
                                                    >
                                                        {{
                                                            item.is_active
                                                                ? "Active"
                                                                : "Inactive"
                                                        }}
                                                    </span>
                                                </div>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </div>

                            <!-- WELCOME DRIPS LIST  -->
                            <div
                                class="col-12"
                                v-if="
                                    selectedTypes.find(
                                        (el) => el.type === 'Welcome Drips'
                                    )
                                "
                            >
                                <v-card-title
                                    class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                                >
                                    <div
                                        class="text-left border-bottom py-1 pl-1 w-100"
                                    >
                                        <span class="step-number ml-2 mr-1"
                                            >4.2</span
                                        >
                                        <span
                                            style="font-size: 11px"
                                            class="mr-4"
                                            >STEP</span
                                        >
                                        <span
                                            class="font-size-11 font-weight-400"
                                            >WELCOME DRIPS:
                                            {{ welcomes.length }}</span
                                        >
                                    </div>
                                    <div class="d-flex ml-2">
                                        <v-tooltip left>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    v-show="
                                                        selectedWelcomes.length
                                                    "
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        selectedWelcomes = []
                                                    "
                                                >
                                                    mdi-close-circle-outline
                                                </v-icon>
                                            </template>
                                            <span
                                                >Click to purge selection.</span
                                            >
                                        </v-tooltip>
                                        <span
                                            class="ml-1"
                                            style="font-size: 45% !important"
                                        >
                                            SELECTED:
                                            {{ selectedWelcomes.length }}
                                        </span>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="searchWelcomes"
                                        append-icon="mdi-magnify"
                                        label="Search ID or Title or Message"
                                        :disabled="loading"
                                        :loading="loading"
                                        single-line
                                        hide-details
                                        class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                                        style="
                                            width: 97%;
                                            border: 1px solid #d1d1d1 !important;
                                        "
                                    ></v-text-field>
                                </v-card-title>
                                <v-card
                                    class="elevation-1 border"
                                    style="margin: 0 !important"
                                >
                                    <v-data-table
                                        v-model="selectedWelcomes"
                                        :headers="welcomesHeaders"
                                        :items="filteredWelcomes"
                                        :loading="
                                            !welcomes.length && loadingWelc
                                        "
                                        show-select
                                        @toggle-select-all="
                                            selectedWelcomes.length !==
                                            welcomes.length
                                                ? (selectedWelcomes = welcomes)
                                                : (selectedWelcomes = [])
                                        "
                                        class="elevation-1"
                                        style="overflow-y: auto"
                                    >
                                        <template
                                            v-slot:[`item.group_id`]="{ item }"
                                        >
                                            <td
                                                class="border-left border-right"
                                                style="
                                                    width: 100px;
                                                    height: 50px;
                                                "
                                            >
                                                {{ item.group_id }}
                                            </td></template
                                        >
                                        <template
                                            v-slot:[`item.title`]="{ item }"
                                        >
                                            <strong>{{ item.title }}</strong
                                            ><br />{{ item.body }}<br />
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </div>

                            <!-- AUDIENCE FILTERS LIST -->
                            <div
                                class="col-12"
                                v-if="
                                    selectedTypes.find(
                                        (el) => el.type === 'Audience Filters'
                                    )
                                "
                            >
                                <v-card-title
                                    class="d-flex flex-column align-items-start border pt-0 px-0 pb-0 border-radius-4"
                                >
                                    <div
                                        class="text-left border-bottom py-1 pl-1 w-100"
                                    >
                                        <span class="step-number ml-2 mr-1"
                                            >4.3</span
                                        >
                                        <span
                                            style="font-size: 11px"
                                            class="mr-4"
                                            >STEP</span
                                        >
                                        <span
                                            class="font-size-11 font-weight-400"
                                            >AUDIENCE FILTERS:
                                            {{ audience.length }}</span
                                        >
                                    </div>
                                    <div class="d-flex ml-2">
                                        <v-tooltip left>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    v-show="
                                                        selectedAudience.length
                                                    "
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="
                                                        selectedAudience = []
                                                    "
                                                >
                                                    mdi-close-circle-outline
                                                </v-icon>
                                            </template>
                                            <span
                                                >Click to purge selection.</span
                                            >
                                        </v-tooltip>
                                        <span
                                            class="ml-1"
                                            style="font-size: 45% !important"
                                        >
                                            SELECTED:
                                            {{ selectedAudience.length }}
                                        </span>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="searchAudience"
                                        append-icon="mdi-magnify"
                                        label="Search ID or Name"
                                        :disabled="loading"
                                        :loading="loading"
                                        single-line
                                        hide-details
                                        class="border-radius-4 pt-0 px-1 mx-3 mt-3 mb-4"
                                        style="
                                            width: 97%;
                                            border: 1px solid #d1d1d1 !important;
                                        "
                                    ></v-text-field>
                                </v-card-title>
                                <v-card
                                    class="elevation-1 border"
                                    style="margin: 0 !important"
                                >
                                    <v-data-table
                                        v-model="selectedAudience"
                                        :headers="audienceHeaders"
                                        :search="searchAudience"
                                        :items="audience"
                                        :loading="
                                            !audience.length && loadingAud
                                        "
                                        item-key="id"
                                        show-select
                                        @toggle-select-all="
                                            selectedAudience.length !==
                                            audience.length
                                                ? (selectedAudience = audience)
                                                : (selectedAudience = [])
                                        "
                                        class="elevation-1"
                                        style="overflow-y: auto"
                                    >
                                        <template v-slot:[`item.id`]="{ item }">
                                            <td
                                                class="border-left border-right"
                                                style="
                                                    width: 100px;
                                                    height: 50px;
                                                "
                                            >
                                                {{ item.id }}
                                            </td></template
                                        >
                                    </v-data-table>
                                </v-card>
                            </div>
                        </div>
                    </div>

                    <!-- CONFIRM BUTTON BLOCK -->
                    <div
                        class="d-flex justify-content-start pl-6"
                        style="height: 40px; padding: 40px 0"
                    >
                        <button
                            class="btn btn-success btn-sm p-2 px-4"
                            style="margin: -21px 0"
                            @click="isDialogToStoreScheduleVisible = true"
                            :disabled="
                                !isCreateScheduleButton ||
                                loading ||
                                processLoading
                            "
                            :loading="loading || processLoading"
                        >
                            Create Schedule
                        </button>
                    </div>
                </div>

                <!-- Failure -->
                <transition
                    class="animate__faster"
                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                >
                    <FailureSnackbar
                        v-if="failure"
                        @update-failure="handleUpdateToFailureSnackbar"
                        :message="errorMsg || 'Error'"
                    />
                </transition>

                <!-- Success -->
                <transition
                    class="animate__faster"
                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                >
                    <SuccessSnackbar
                        v-if="success"
                        @update-success="handleUpdateToSuccessSnackbar"
                        message="Successfully!"
                    />
                </transition>

                <!-- Warning -->
                <transition
                    class="animate__faster"
                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                >
                    <Warnings
                        v-if="showWarningPopUp"
                        @didClose="showWarningPopUp = false"
                        :warningText="warningText"
                    />
                </transition>
                <div
                    class="spinner-border text-primary position-fixed"
                    style="top: 50%; left: 55%"
                    v-if="processLoading"
                    role="status"
                >
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <v-dialog
            v-model="isDialogToStoreScheduleVisible"
            v-if="isDialogToStoreScheduleVisible"
            persistent
            width="350px"
            @click:outside="closeStoreScheduleDialog()"
        >
            <v-form v-model="valid" ref="form" lazy-validation>
                <v-card style="margin: 0 !important">
                    <v-card-title class="justify-content-center">
                        <span class="text-h5">Spam Schedule</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row justify="center" dense>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Name*"
                                        v-model="scheduleToStore[0].name"
                                        :rules="[rules.required]"
                                        :loading="loading"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <!-- DURATION -->
                                <v-col cols="12">
                                    <v-dialog
                                        ref="modalTime"
                                        v-model="modalTime"
                                        :return-value.sync="
                                            scheduleToStore[0].time
                                        "
                                        persistent
                                        width="290px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="
                                                    scheduleToStore[0].time
                                                "
                                                :rules="[rules.required]"
                                                label="Duration*"
                                                prepend-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="modalTime"
                                            v-model="scheduleToStore[0].time"
                                            full-width
                                            format="24hr"
                                            use-seconds
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="modalTime = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="
                                                    $refs.modalTime.save(
                                                        scheduleToStore[0].time
                                                    )
                                                "
                                            >
                                                OK
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                                <!-- DATE START -->
                                <v-col cols="6">
                                    <v-menu
                                        ref="menuDateStart"
                                        v-model="menuDateStart"
                                        :close-on-content-click="false"
                                        :return-value.sync="
                                            scheduleToStore[0].date_start[0]
                                                .date
                                        "
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="
                                                    scheduleToStore[0]
                                                        .date_start[0].date
                                                "
                                                :rules="[rules.required]"
                                                label="Date Start"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="
                                                scheduleToStore[0].date_start[0]
                                                    .date
                                            "
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menuDateStart = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="
                                                    $refs.menuDateStart.save(
                                                        scheduleToStore[0]
                                                            .date_start[0].date
                                                    )
                                                "
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <!-- TIME START -->
                                <v-col cols="6">
                                    <v-dialog
                                        ref="dialogTimeStart"
                                        v-model="modalTimeStart"
                                        :return-value.sync="
                                            scheduleToStore[0].date_start[0]
                                                .time
                                        "
                                        persistent
                                        width="290px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="
                                                    scheduleToStore[0]
                                                        .date_start[0].time
                                                "
                                                :rules="[rules.required]"
                                                label="Time Start*"
                                                prepend-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="modalTimeStart"
                                            v-model="
                                                scheduleToStore[0].date_start[0]
                                                    .time
                                            "
                                            full-width
                                            ampm-in-title
                                            format="ampm"
                                            use-seconds
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="modalTimeStart = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="
                                                    $refs.dialogTimeStart.save(
                                                        scheduleToStore[0]
                                                            .date_start[0].time
                                                    )
                                                "
                                            >
                                                OK
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                                <!-- DATE END -->
                                <v-col cols="6">
                                    <v-menu
                                        ref="menuDateEnd"
                                        v-model="menuDateEnd"
                                        :close-on-content-click="false"
                                        :return-value.sync="
                                            scheduleToStore[0].date_end[0].date
                                        "
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="
                                                    scheduleToStore[0]
                                                        .date_end[0].date
                                                "
                                                :rules="[rules.required]"
                                                label="Date End"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="
                                                scheduleToStore[0].date_end[0]
                                                    .date
                                            "
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menuDateEnd = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="
                                                    $refs.menuDateEnd.save(
                                                        scheduleToStore[0]
                                                            .date_end[0].date
                                                    )
                                                "
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <!-- TIME END -->
                                <v-col cols="6">
                                    <v-dialog
                                        ref="dialogTimeEnd"
                                        v-model="modalTimeEnd"
                                        :return-value.sync="
                                            scheduleToStore[0].date_end[0].time
                                        "
                                        persistent
                                        width="290px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="
                                                    scheduleToStore[0]
                                                        .date_end[0].time
                                                "
                                                :rules="[rules.required]"
                                                label="Time End*"
                                                prepend-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="modalTimeEnd"
                                            v-model="
                                                scheduleToStore[0].date_end[0]
                                                    .time
                                            "
                                            full-width
                                            ampm-in-title
                                            format="ampm"
                                            use-seconds
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="modalTimeEnd = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="
                                                    $refs.dialogTimeEnd.save(
                                                        scheduleToStore[0]
                                                            .date_end[0].time
                                                    )
                                                "
                                            >
                                                OK
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                                <!-- DAYS OF THE WEEK -->
                                <v-col cols="6">
                                    <v-select
                                        label="Days of The Week*"
                                        v-model="
                                            scheduleToStore[0].days_of_week
                                        "
                                        :items="[
                                            'Monday',
                                            'Tuesday',
                                            'Wednesday',
                                            'Thursday',
                                            'Friday',
                                            'Saturday',
                                            'Sunday',
                                        ]"
                                        :loading="loading"
                                        :rules="[rules.required]"
                                        multiple
                                    >
                                        <template v-slot:prepend-item>
                                            <v-checkbox
                                                :input-value="
                                                    allSelectedDaysOfTheWeek
                                                "
                                                label="Select All"
                                                @change="
                                                    toggleDaysOfTheWeekSelectAll
                                                "
                                                color="primary"
                                                class="pl-4"
                                            >
                                            </v-checkbox>
                                            <v-divider
                                                class="m-0 mb-4"
                                            ></v-divider>
                                        </template>
                                        <template
                                            v-slot:selection="{ item, index }"
                                        >
                                            <span
                                                v-if="
                                                    index === 0 &&
                                                    scheduleToStore[0]
                                                        .days_of_week.length ===
                                                        7
                                                "
                                                >All</span
                                            >
                                            <span
                                                v-if="
                                                    index === 0 &&
                                                    scheduleToStore[0]
                                                        .days_of_week.length !==
                                                        7
                                                "
                                                >{{ item }}&nbsp;</span
                                            >
                                            <span
                                                v-if="
                                                    index === 1 &&
                                                    scheduleToStore[0]
                                                        .days_of_week.length !==
                                                        7
                                                "
                                                class="grey--text text-caption"
                                            >
                                                (+{{
                                                    scheduleToStore[0]
                                                        .days_of_week.length -
                                                    1
                                                }})
                                            </span>
                                        </template>
                                    </v-select>
                                </v-col>
                                <!-- FREQUENCY -->
                                <v-col cols="6">
                                    <v-select
                                        label="Frequency*"
                                        v-model="scheduleToStore[0].frequency"
                                        :items="[
                                            'incessant',
                                            'secondly',
                                            'minutely',
                                            'hourly',
                                            'daily',
                                            'weekly',
                                            'monthly',
                                            'yearly',
                                        ]"
                                        :loading="loading"
                                        :rules="[rules.required]"
                                        required
                                    ></v-select>
                                </v-col>
                                <!-- TIMEZONES -->
                                <v-col cols="12">
                                    <v-combobox
                                        v-model="scheduleToStore[0].timezone"
                                        :items="timezones"
                                        :rules="[rules.required]"
                                        label="Timezone*"
                                        hide-selected
                                        dense
                                    ></v-combobox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <!-- Actions -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-2"
                            text
                            :loading="loading"
                            @click="closeStoreScheduleDialog()"
                        >
                            Close
                        </v-btn>
                        <v-btn
                            color="blue darken-2"
                            text
                            :loading="loading"
                            @click="sendRequestToMigrateRecurringMessages"
                        >
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>
  
  <script>
import Schedules from "../../apis/Schedules.js";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Warnings from "../popUps/Warnings.vue";
import Spinner from "../popUps/Spinner.vue";
import common from "../../mixins/common";

import { mapState, mapActions, mapGetters } from "vuex";

import { chunk } from "../../utils";
import transformRecurringToStore from "../../transformers/recurring/transformRecurringToStore.js";

const moment = require("moment-timezone");

export default {
    name: "RecurringMigration",
    components: {
        Warnings,
        SuccessSnackbar,
        FailureSnackbar,
        Spinner,
        Error,
    },
    mixins: [common],
    data() {
        return {
            openTreeview: [],
            selectedSendTimeForSorting: [],
            selectedAudienceFiltersForSorting: [],
            itemsSendTime: [
                {
                    id: 0,
                    name: "Send Time:",
                    children: [],
                },
            ],
            loading: true,
            isDialogToStoreScheduleVisible: false,
            selectedRecurringStatus: 1,
            selectedRecurrings: [],
            processLoading: false,
            loadingRecur: true,
            errorMsg: "",
            domains: [],
            error: false,
            success: false,
            searchDmnsFrom: "",
            searchDmnsTo: "",
            searchRecurrings: "",
            recurrings: [],
            dmnsFrom: [],
            dmnsTo: [],
            types: [],

            scheduleToStore: [
                {
                    domain_id: null,
                    type: "spam-recurring",
                    name: "",
                    frequency: [],
                    drips: [],
                    audiences: [],
                    time: null,
                    date_start: [
                        {
                            date: null,
                            time: null,
                        },
                    ],
                    date_end: [
                        {
                            date: null,
                            time: null,
                        },
                    ],
                    days_of_week: [],
                    timezone: null,
                },
            ],

            selectedScheduleRelation: "Recurring",
            rules: {
                required: (value) =>
                    Array.isArray(value)
                        ? !!value.length || "Required field."
                        : !!value || "Required field.",
                isNotNull: (value) => value !== null || "Required field.",
            },

            valid: true,
            warningText: "",
            showWarningPopUp: false,

            menu: false,
            menuDateStart: false,
            menuDateEnd: false,
            modalTimeStart: false,
            modalTimeEnd: false,
            modalTime: false,
            timezones: moment.tz.names(),

            dmnsFromHeaders: [
                {
                    text: "Domains: ",
                    align: "left",
                    sortable: false,
                    value: "url",
                    class: "header-copy",
                },
                {
                    text: "Tags: ",
                    align: "left",
                    sortable: true,
                    value: "domain_tags",
                    class: "header-copy",
                },
                {
                    text: "Status: ",
                    align: "left",
                    value: "status",
                    class: "header-copy",
                },
            ],
            dmnsToHeaders: [
                {
                    text: "Domains: ",
                    align: "left",
                    sortable: false,
                    value: "url",
                },
                {
                    text: "Tags: ",
                    align: "left",
                    filterable: true,
                    value: "tags",
                },
                {
                    text: "Status: ",
                    align: "left",
                    value: "status",
                },
            ],
            typesHeaders: [
                {
                    text: "Types: ",
                    align: "left",
                    sortable: false,
                    value: "type",
                },
            ],
            recurringsHeaders: [
                {
                    text: "ID",
                    value: "id",
                    align: "left",
                    sortable: false,
                },
                {
                    text: "Notification",
                    value: "title",
                    align: "left",
                    sortable: false,
                },
                {
                    text: "Status",
                    value: "status",
                    align: "left",
                    sortable: false,
                },
            ],
            failure: false,
            selectedTypes: [],
            selectedDmnsTo: [],
            selectedDmnsFrom: [],
            selectedRecurrings: [],
        };
    },
    mounted() {
        this.show(`?with[domain_tags]=*`)
            .then((response) => {
                this.dmnsTo.push(response.data.data);
                this.dmnsFrom.push(response.data.data);
            })
            .finally(() => {
                this.loading = false;
            });

        this.getRecurringMessages();

        queueMicrotask(() => {
            this.loading = false;
            this.types.push({
                type: "Recurring Drips",
            });
        });
    },
    computed: {
        ...mapState({
            recurring: (state) => state.push.recurring,
        }),
        ...mapGetters(["roles"]),

        filteredRecurrings() {
            return this.recurrings.filter((p) => {
                return (
                    p.title
                        .toLowerCase()
                        .indexOf(this.searchRecurrings.toLowerCase()) != -1 ||
                    (null !== p.body &&
                        p.body
                            .toLowerCase()
                            .indexOf(this.searchRecurrings.toLowerCase()) !=
                            -1) ||
                    (null !== p.url &&
                        p.url
                            .toLowerCase()
                            .indexOf(this.searchRecurrings.toLowerCase()) !=
                            -1) ||
                    p.id.toString().includes(this.searchRecurrings)
                );
            });
        },
        filteredDomainsTo() {
            if (this.dmnsTo[0] !== undefined) {
                return this.dmnsTo[0].filter((p) => {
                    return (
                        (p.url &&
                            p.url
                                .toLowerCase()
                                .indexOf(this.searchDmnsTo.toLowerCase()) !=
                                -1) ||
                        p.id.toString().includes(this.searchDmnsTo)
                    );
                });
            } else {
                return [];
            }
        },
        filteredDomainsFrom() {
            if (this.dmnsFrom[0] !== undefined) {
                return this.dmnsFrom[0].filter((p) => {
                    return (
                        (p.url &&
                            p.url
                                .toLowerCase()
                                .indexOf(this.searchDmnsFrom.toLowerCase()) !=
                                -1) ||
                        p.id.toString().includes(this.searchDmnsFrom)
                    );
                });
            } else {
                return [];
            }
        },
        allSelectedDaysOfTheWeek() {
            return this.scheduleToStore[0].days_of_week.length === 7;
        },
        isCreateScheduleButton() {
            return (
                this.selectedDmnsFrom.length &&
                this.selectedDmnsTo.length &&
                this.selectedRecurrings.length &&
                this.selectedTypes.length
            );
        },
    },
    methods: {
        ...mapActions(["getRecurringDrips", "show"]),

        calculatedHeight(index) {
            return index > 1 ? "-" + (48 * index - 48) + "px" : "";
        },
        toggleMenu() {
            this.openTreeview = [];
        },
        treeviewActiveAudienceFilters(array) {
            this.selectedAudienceFiltersForSorting = array;
        },
        treeviewActiveSendTime(array) {
            this.selectedSendTimeForSorting = array;
        },
        prepareRecurringToStore(recurring) {
            if (!recurring || typeof recurring !== "object") {
                throw new Error("Invalid recurring drip provided.");
            }

            let deepClonedRecurring = structuredClone(recurring);
            let preparedRecurring = transformRecurringToStore(
                deepClonedRecurring,
                this.selectedDmnsTo[0].id
            );

            preparedRecurring.schedule.type = "spam-recurring";

            return preparedRecurring;
        },
        async getRecurringMessages() {
            this.loading = true;

            let scheduleRelation = null;

            switch (this.selectedScheduleRelation) {
                case "Recurring":
                    scheduleRelation =
                        "&with[schedules.audiences]=domain_id,id,name,query&whereRelation[schedules]=type::recurring";
                    break;
                case "Tail Recurring":
                    scheduleRelation =
                        "&with[schedules]=*&whereRelation[schedules]=type::tail-recurring";
                    break;
                default:
                    break;
            }

            let additionalAudienceParams = this
                .selectedAudienceFiltersForSorting.length
                ? `&whereRelation[schedules.audiences]=segments.id::${this.selectedAudienceFiltersForSorting.toString()}`
                : "";
            let additionalTimeParams = this.selectedSendTimeForSorting.length
                ? `&whereRelation[schedules]=time::${this.selectedSendTimeForSorting}`
                : "";

            try {
                for (let dmn of this.selectedDmnsFrom) {
                    let offset = 0;
                    let limit = 500;
                    let hasMoreData = true;

                    while (hasMoreData) {
                        const params =
                            `?order_by=id:desc&where[is_active]=${this.selectedRecurringStatus}&where[domain_id]=${dmn.id}` +
                            `&limit=${limit}&offset=${offset}` +
                            additionalAudienceParams +
                            additionalTimeParams +
                            scheduleRelation;

                        const response = await this.getRecurringDrips({
                            params,
                        });

                        const data = response.data.data;
                        this.recurrings.push(...data);

                        if (data.length < 500) {
                            hasMoreData = false;
                        } else {
                            offset += limit;
                        }
                    }
                }
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
                this.loadingRecur = false;
            }
        },
        addDripsIntoSchedule() {
            const chunks = chunk(this.selectedRecurrings, 500);
            let transformedRecurringChunks = null;

            for (let drip of chunks) {
                transformedRecurringChunks = drip.map((recurring) => {
                    return this.prepareRecurringToStore(recurring);
                });
            }

            this.scheduleToStore[0].drips = transformedRecurringChunks;
        },
        toggleDaysOfTheWeekSelectAll(isChecked) {
            if (isChecked) {
                this.scheduleToStore[0].days_of_week = [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday",
                ];
            } else {
                this.scheduleToStore[0].days_of_week = [];
            }
        },
        async sendRequestToMigrateRecurringMessages() {
            if (!this.$refs.form.validate()) {
                return false;
            }

            this.processLoading = true;

            if (!this.selectedRecurrings.length) {
                this.processLoading = false;

                throw new Error("Provided selected recurring drips are empty.");
            }

            await this.addDripsIntoSchedule();

            let deepCloneOfSchedule = structuredClone(this.scheduleToStore);

            if (Array.isArray(this.scheduleToStore[0].days_of_week)) {
                deepCloneOfSchedule[0].days_of_week =
                    deepCloneOfSchedule[0].days_of_week.join(" ");
            }

            deepCloneOfSchedule[0].domain_id = this.selectedDmnsTo[0].id;
            deepCloneOfSchedule[0].date_start =
                deepCloneOfSchedule[0].date_start[0].date.concat(
                    " ",
                    deepCloneOfSchedule[0].date_start[0].time
                );
            deepCloneOfSchedule[0].date_end =
                deepCloneOfSchedule[0].date_end[0].date.concat(
                    " ",
                    deepCloneOfSchedule[0].date_end[0].time
                );

            try {
                await Schedules.createOrUpdate(deepCloneOfSchedule, false)
                    .then((response) => {
                        if (response.status === 200) {
                            return { success: true, response };
                        } else {
                            throw new Error(
                                `Request failed with status ${response.status}`
                            );
                        }
                    })
                    .catch((error) => {
                        console.error("Request failed:", error);
                        return { success: false, error };
                    })
                    .finally(() => {
                        this.closeStoreScheduleDialog();
                        this.resetScheduleToStore();
                    });
            } catch (error) {
                console.error(error);

                this.handleError(error);
            } finally {
                if (!this.failure && !this.errorMsg) {
                    this.handleSuccess();
                }

                this.processLoading = false;
            }
        },
        handleSuccess() {
            this.loadingRecur = true;

            setTimeout(() => {
                this.selectedRecurrings = [];
                this.success = true;
                this.loadingRecur = false;
                this.processLoading = false;
            }, 1500);
        },
        handleError(error) {
            if (error.response) {
                this.errorMsg = error.response.data.message;
                //this.error = true;

                this.failure = true;
                setTimeout(() => {
                    this.errorMsg = "";
                    this.processLoading = false;
                }, 1000);
            }
        },
        checkMainWarnings() {
            if (
                !this.selectedDmnsFrom.length ||
                (!this.selectedDmnsTo.length && this.selectedTypes.length)
            ) {
                this.showWarningPopUp = true;
                this.warningText = this.selectedDmnsTo.length
                    ? "Select domain(s) to obtain items from!"
                    : "Select domain(s) to obtain items from and to migrate to!";
            }
        },
        resetScheduleToStore() {
            this.scheduleToStore = [
                {
                    domain_id: null,
                    type: "spam-recurring",
                    name: "",
                    frequency: [],
                    drips: [],
                    audiences: null,
                    time: null,
                    date_start: [
                        {
                            date: null,
                            time: null,
                        },
                    ],
                    date_end: [
                        {
                            date: null,
                            time: null,
                        },
                    ],
                    days_of_week: [],
                    timezone: null,
                },
            ];
        },
        closeStoreScheduleDialog() {
            this.isDialogToStoreScheduleVisible = false;
        },
    },
    watch: {
        selectedScheduleRelation() {
            this.getRecurringMessages();
        },
        selectedRecurringStatus() {
            this.recurrings = [];

            this.getRecurringMessages();
        },
        selectedTypes(new_array, old_array) {
            this.loadingRecur = true;

            console.log(
                "🚀 ~ selectedTypes ~ new_array:",
                new_array,
                old_array
            );

            let dmnsFrom = this.selectedDmnsFrom.length
                ? this.selectedDmnsFrom.map((el) => el.id)
                : [];

            !this.recurrings.length ? (this.loadingRecur = true) : null;

            this.checkMainWarnings();

            if (dmnsFrom.length) {
                console.log(new_array[0].type === "Recurring Drips");

                if (new_array[0].type === "Recurring Drips") {
                    this.getRecurringMessages();
                } else {
                    this.recurrings = [];
                    this.deepCopyOfAllRecurrings = [];
                    this.loadingRecur = false;
                }
            }
        },
        selectedDmnsFrom(dmn) {
            if (!dmn.length) {
                this.loadingRecur = true;

                this.recurrings = [];

                this.loadingRecur = false;
            } else if (dmn.length && this.selectedTypes.length) {
                if (this.selectedTypes[0].type === "Recurring Drips") {
                    this.loadingRecur = true;
                    this.recurrings = [];

                    this.getRecurringMessages();
                }

                for (let i in dmn) {
                    if (
                        this.selectedTypes.findIndex(
                            (el) => el.type === "Recurring Drips"
                        ) === -1
                    ) {
                        this.recurrings = [];
                        this.loadingRecur = false;
                    } else if (
                        this.selectedTypes.findIndex(
                            (el) => el.type === "Recurring Drips"
                        ) === -1
                    ) {
                        this.recurrings = [];
                        this.loadingRecur = false;
                    }
                }
            }
        },
    },
};
</script>
  
<style scoped>
.hover--grey:hover {
    background-color: #eeeeee;
}
.active--blue:selected {
    background-color: #c0daf3 !important;
}
small {
    color: #838181;
}
.border-radius-4 {
    border-radius: 4px !important;
}
.step-number {
    font-size: 9px;
    color: #ffffff;
    font-weight: 700;
    background: #3171b3;
    border-radius: 100%;
    padding: 4px 7px;
}
.tag:hover {
    color: #646262;
}
.tag {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7f7f7f;
    padding: 6px 10px;
    /* width: 38px; */
    height: 25px;
    background: #dfe1e5;
    border-radius: 4px;
}
.inActiveStatus {
    color: #e45b54;
}
.activeStatus {
    color: #52a451 !important;
}
.inActiveStatusSign {
    /* Rectangle 189 */
    /* position: absolute; */
    width: 10px;
    height: 10px;
    left: 8px;
    top: 15px;

    /* Red */
    background: #e45b54;
    border-radius: 1px;
}

.activeStatusSign {
    /* Rectangle 189 */
    /* position: absolute; */
    width: 10px;
    height: 10px;
    left: 8px;
    top: 15px;

    /* Green */
    background: #52a451 !important;
    border-radius: 1px;
}
.font-size-11 {
    font-size: 11px !important;
}
.font-weight-400 {
    font-weight: 400 !important;
}

.form-control {
    width: 200px;
}
.col-md-9.col-sm-12 div + div {
    margin: 0 0 14px 0;
}
option,
select {
    color: #fff;
}
</style>
  